<template>
  <!--期望射球 关系图表-->
  <div class="expectGoalScatter">
    <div class="expectGoal_box" :class="isAutoExportPng ? 'autoExportPng' : ''">
      <div
        class="canvasBox"
        ref="expectGoal"
        :style="{ height: `${pHeight}px` }"
      ></div>
    </div>
    <div class="expectGoal_right" v-if="tipFlag">
      <div
        v-if="echartData.basisStatisticsModel.resultData[1]"
        class="expectGoal_right_top"
      >
        <p
          v-for="(item, index) of echartData.basisStatisticsModel
            .dimensionNames"
          :key="index"
        >
          <span>
            {{ echartData.basisStatisticsModel.resultData[1][index] }}
          </span>
          {{ item }}
        </p>
      </div>

      <div class="expectGoal_right_cicle">
        <p>
          <i class="cicle1"></i>
          <span>进球</span>
        </p>
        <p>
          <i class="cicle2"></i>
          <span>射正</span>
        </p>
        <p>
          <i class="cicle3"></i>
          <span>射偏</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
// 原点位于左上
import datas from './expectGoalScatter.json'
import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
export default {
  name: 'expectGoalScatter',
  props: {
    // echartData: {
    //   default: function() {
    //     return {
    //       objectInfos: [],
    //       basisStatisticsModel: {}
    //     };
    //   }
    // },
    tipFlag: {
      type: Boolean,
      default: true,
    },
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
  },
  mixins: [canvasToImage_base64_data_mixin],
  data() {
    return {
      lt: {
        // 原点
        name: 'lt',
        x: 0,
        y: 0,
        symbolSize: 0, //大小
      },
      rb: {
        // 边界
        symbolSize: 20,
      },
      linesData: [], // 散点位置
      splashesSize: 0.08, // 散点大小，依据宽度进行计算
      positive: '#CC8FD9', //射正
      deflection: '#098CCB', //射偏
      score: '#D0021B', //射进
      echartData: null,
      myPassesChart: null,
      proportion: 1.53,
      pWidth: null,
      pHeight: null,
      initFlag: false,
    }
  },
  watch: {
    echartData() {
      if (this.initFlag) {
        this.countLinesData()
        this.initChart()
      }
    },
  },
  created() {
    this.echartData = datas
  },
  beforeDestroy() {
    //性能优化，防止溢出
    if (this.myPassesChart) {
      this.myPassesChart.dispose() //销毁echarts实例，防止内侧泄露
    }
    this.echartData = null
  },
  mounted() {
    this.$nextTick(() => {
      this.initDomWH()
      this.countLinesData()
      setTimeout(() => {
        this.initFlag = true
        this.initChart()
      }, 10)
    })
  },
  methods: {
    initDomWH() {
      const echartsBoxDom = this.$refs.expectGoal
      console.debug('echartsBoxDom.clientWidth:', echartsBoxDom.clientWidth)
      //横向一个
      this.pWidth = echartsBoxDom.clientWidth

      this.pHeight = Math.floor(this.pWidth / this.proportion)
      console.debug('this.pWidth:', this.pWidth, this.pHeight)
    },
    initChart() {
      if (!this.myPassesChart) {
        this.myPassesChart = this.$echarts.init(this.$refs.expectGoal)
      }
      let options = {
        series: [
          {
            type: 'graph',
            layout: 'none',
            left: 0,
            top: 0,
            bottom: 0,
            right: 0,
            symbolSize: 10,
            label: {
              show: true,
            },
            edgeSymbol: ['circle', 'arrow'],
            edgeLabel: {
              fontSize: 10,
            },
            data: this.linesData,
          },
        ],
      }
      this.myPassesChart.setOption(options)
      if (this.isAutoExportPng) {
        setTimeout(() => {
          this.upLoad(this.$refs.expectGoal, true, 'uploadData')
        }, 500)
      }
    },
    countLinesData() {
      let linesDataHold = []
      linesDataHold.push(this.lt) // 固定原点eventData
      this.echartData.eventData.forEach((item, index) => {
        linesDataHold.push({
          x: Math.floor(this.pWidth * (item.x / 100)),
          y: Math.floor(this.pHeight * ((100 - item.y) / 100)),
          symbolSize:
            this.pWidth *
            item.r.scale *
            (item.r.scale >= 0.1
              ? item.r.scale >= 0.4
                ? 0.025
                : 0.045
              : 0.28),
          itemStyle: {
            color:
              item.type == 1
                ? this.positive
                : item.type == 2
                ? this.deflection
                : this.score,
          },
        })
      })
      linesDataHold.push({
        // 设置当前边界值
        name: 'rb',
        x: this.pWidth,
        y: this.pHeight,
        symbolSize: 0,
      })
      this.linesData = linesDataHold
      console.debug('this.linesData:', this.linesData)
    },
  },
}
</script>

<style lang="scss" scoped>
.expectGoalScatter {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  .expectGoal_box {
    width: 59%;
    border: 0.416vw solid #eaedf1;
    background: #eaedf1;
    border-radius: 0.694vw;
    &.autoExportPng {
      width: 100%;
    }
    .canvasBox {
      width: 100%;
      background-image: var(--mixtmt_ball_bg);
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-position: center;
    }
  }

  .expectGoal_right {
    width: 6.94vw;
    height: 100%;
    display: flex;
    display: -webkit-flex;
    text-align: right;
    justify-content: space-between;
    flex-direction: column;
    .expectGoal_right_top {
      & > p {
        height: 2.083vw;
        line-height: 2.083vw;
        font-size: 0.833vw;
        color: #333;
        color: var(--mixtmt_greyColor_main);
        & > span {
          font-weight: bold;
        }
      }
    }

    .expectGoal_right_cicle {
      display: flex;
      display: -webkit-flex;
      flex-direction: column;
      & > p {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-end;
        align-items: center;
        line-height: 1.11vw;
        & > i {
          width: 0.556vw;
          height: 0.556vw;
          border-radius: 50%;
          display: inline-block;
        }
        .cicle1 {
          background: #d0021b;
        }
        .cicle2 {
          background: #098ccb;
        }
        .cicle3 {
          background: #cc8fd9;
        }
        span {
          padding-left: 0.694vw;
          font-size: 0.833vw;
          color: #b9b9b9;
          text-align: center;
        }
      }
    }
  }
}
</style>
